















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IStock from '@/store/models/IStock';
import FilterMenu from '@/components/shared/FilterMenu.vue';
import { delay, difference, uniq, without } from "lodash";
import moment from 'moment';
import ISellsDetail from '@/store/models/ISellsDetail';
import SellsDetailStockSelector from '@/components/selectors/Sells/SellsDetailStockSelector.vue';
import ISells from '@/store/models/ISells';

@Component({
    components: {
        Snackbar,
        FilterMenu,
        SellsDetailStockSelector
    }
})
export default class SellsDetailSelector extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    StockList !: IStock[];
    @Prop({ type: Array, required: true })
    StockListCustomerPalletsAmount !: IStock[];
    @Prop({ type: Array, required: true })
    SellDetailList !: ISellsDetail[];
    @Prop({ default: false })
    overlay !: boolean;
    @Prop()
    SelectedSell !: ISells;

    inboundCodeFilter : string[] = [];
    goodFilter : string[] = [];
    dialog: boolean = false;
    sortBy: string = 'goodName';
    sortDesc: boolean = false;
    menu2: boolean = false;
    selectedStockCustomerToDelivery : IStock[] | null = null;

    // Declare the properties explicitly
    stockListCopy: IStock[] = [];
    stockListCustomerPalletsAmountCopy: IStock[] = [];

    created() {
        // Initialize the properties based on the props
        this.stockListCopy = [...this.StockList];
        this.stockListCustomerPalletsAmountCopy = [...this.StockListCustomerPalletsAmount];
    }

    getStockPalletsAmount(item: IStock) {
        this.$emit('getStockPalletsAmount', item);
    }

    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    get canEdit() {
        if (this.SelectedSell) {
            if (this.SelectedSell.statusName.toLowerCase() === 'completed') {
                return false;
            }
        }
        return true;
    }

    get headerCustom() {
        return [
            { text: 'Good', align: 'start', value: 'goodName' },
            { text: 'Inbound', value: 'inboundCode' },
            { text: 'Pallet type', value: 'palletName' },
            { text: 'Pallets', value: 'palletsAmount' },
            { text: 'Cases / pallet', value: 'casesAmountPallet' },
            { text: 'Total cases', value: 'totalCases' },
            { text: 'Goods per case', value: 'goodsPerCase' },
            { text: 'Actions', value: 'actions' }
        ];
    }

    get TotalCases() {
        return this.SellDetailList.reduce(
            (sum, current) => Number(sum) + Number(current.totalCases || current.casesAmountPallet || 0),
            0
        );
    }

    get TotalPallets() {
        return this.SellDetailList.reduce(
            (sum, current) => Number(sum) + Number(current.palletsAmount || 0),
            0
        );
    }

    get TotalGoods() {
        return this.SellDetailList.reduce(
            (sum, current) => Number(sum) + Number((current.goodsPerCase || 0) * (current.totalCases || current.casesAmountPallet || 0)),
            0
        );
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    get inboundCodes() : string[] {
        return uniq(
            this.SellDetailList
            .filter(b => b.inboundCode !== null)
            .map(b => b.inboundCode)
        );
    }

    get goodNames() : string[] {
        return uniq(
            this.SellDetailList
            .filter(b => b.goodName !== null)
            .map(b => b.goodName)
        );
    }

    clearAllFilters() : void {
        this.inboundCodeFilter = [];
        this.goodFilter = [];
        this.showMessageInfo("All filters have been deselected");
    }

    @Watch('StockList')
    onChangeStockList() {
        this.stockListCopy = [...this.StockList];
    }

    @Watch('StockListCustomerPalletsAmount')
    onChangeStockListCustomerPalletsAmount() {
        this.stockListCustomerPalletsAmountCopy = [...this.StockListCustomerPalletsAmount];
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    close() : void {
        this.dialog = false;
    }

    saveSellDetail() {
        this.$emit("saveSellDetail", this.selectedStockCustomerToDelivery);
        this.close();
    }

    deleteSellDetail(item: ISellsDetail) {
        this.$emit("deleteSellDetail", item);
    }

    async ResetSellDetailGood() {
        this.selectedStockCustomerToDelivery = [];
        this.dialog = true; // <-- ABRIR EL DIÁLOGO INMEDIATAMENTE

        await this.$emit("onClickAddGoods");

        // Espera a que StockList y StockListCustomerPalletsAmount se actualicen (esto se hará por @Watch)
        this.stockListCopy = [...this.StockList];
        this.stockListCustomerPalletsAmountCopy = [...this.StockListCustomerPalletsAmount];
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
